import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export default function HowItWorks() {
  const { t } = useLang();
  const items = t("steps.items");

  return (
    <section id="como-funciona" data-testid="how-it-works-section" className="bg-[#0B2E4A] text-[#FAF6EE] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="max-w-2xl mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#D9A854] mb-3">{t("steps.eyebrow")}</p>
          <h2 className="font-display font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-balance">
            {t("steps.title")}
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {Array.isArray(items) && items.map(([title, text], i) => (
            <motion.div
              key={title}
              data-testid={`step-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
              className="relative"
            >
              <div className="font-display font-medium text-6xl text-[#D9A854]/30 leading-none">0{i + 1}</div>
              <h3 className="font-display font-semibold text-xl mt-4">{title}</h3>
              <p className="text-sm text-[#F1E7D6]/70 leading-relaxed mt-2">{text}</p>
              {i < 3 && <div className="hidden lg:block absolute top-8 -right-5 w-6 h-px bg-[#D9A854]/30" />}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
